import API from '@/network/API'
import { CustomSuccessData } from 'axios'
import UserInfo from '@/utils/account-manager/models/UserInfo'
import UserShopPoints from '../models/UserShopPoints'
import ChannelManager from '@/utils/channel-manager'

const _url = '/user/v1.0'
const personalInformationUrl = `${_url}/personalInformation`

async function fetchUserInformation(): Promise<CustomSuccessData<UserInfo>> {
  return API.instance().get<UserInfo>(personalInformationUrl)
}

function _buildUserShopPointsUrl(shopId: string): string {
  const channelManager = ChannelManager.instance()
  const pointChannel = channelManager.getChannel()
  return `/restaurantOrders/v1.0/points/restaurants/${shopId}?channel=${pointChannel}`
}

/**
 * 获取用户在指定店铺的积分信息(非circle eats渠道使用)
 * @param shopId 店铺ID
 * @returns 用户在指定店铺的积分信息
 */
async function fetchUserShopPoints(shopId: string): Promise<CustomSuccessData<UserShopPoints>> {
  return API.instance().get<UserShopPoints>(_buildUserShopPointsUrl(shopId))
}

export { fetchUserInformation, fetchUserShopPoints }
